import { footerData, contactInfo, logos } from '../data/mock';
import { MapPin, Phone, Mail, Globe } from 'lucide-react';

export const Footer = () => {
  return (
    <footer className="bg-[#070E1A] border-t border-white/5">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-16">
        <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-12">
          {/* Brand */}
          <div className="lg:col-span-1">
            <div className="flex items-center gap-2.5 mb-5">
              <img src={logos.iconOnly} alt="Chris IELTS" className="w-11 h-11 rounded-lg object-contain" />
              <div>
                <span className="text-white font-bold text-xl" style={{ fontFamily: 'Poppins, sans-serif' }}>Chris</span>
                <span className="text-[#E8C87A] font-bold text-xl ml-1" style={{ fontFamily: 'Poppins, sans-serif' }}>IELTS</span>
              </div>
            </div>
            <p className="text-white/40 text-sm leading-relaxed mb-5">{footerData.description}</p>
            <div className="flex items-center gap-2 text-white/40 text-sm">
              <Globe className="w-4 h-4 text-[#E8C87A]" />
              <a href={`https://${contactInfo.website}`} target="_blank" rel="noopener noreferrer" className="hover:text-[#E8C87A] transition-colors duration-300">
                {contactInfo.website}
              </a>
            </div>
          </div>

          {/* Quick Links */}
          <div>
            <h4 className="text-white font-semibold text-base mb-5" style={{ fontFamily: 'Poppins, sans-serif' }}>Quick Links</h4>
            <ul className="space-y-3">
              {footerData.quickLinks.map((link) => (
                <li key={link.label}>
                  <a href={link.href} className="text-white/40 hover:text-[#E8C87A] transition-colors duration-300 text-sm">
                    {link.label}
                  </a>
                </li>
              ))}
            </ul>
          </div>

          {/* Destinations */}
          <div>
            <h4 className="text-white font-semibold text-base mb-5" style={{ fontFamily: 'Poppins, sans-serif' }}>Destinations</h4>
            <ul className="space-y-3">
              {footerData.destinations.map((link) => (
                <li key={link.label}>
                  <a href={link.href} className="text-white/40 hover:text-[#E8C87A] transition-colors duration-300 text-sm">
                    {link.label}
                  </a>
                </li>
              ))}
            </ul>
          </div>

          {/* Contact */}
          <div>
            <h4 className="text-white font-semibold text-base mb-5" style={{ fontFamily: 'Poppins, sans-serif' }}>Contact</h4>
            <div className="space-y-4">
              <div className="flex items-start gap-3">
                <MapPin className="w-4 h-4 text-[#E8C87A] flex-shrink-0 mt-1" />
                <a href={contactInfo.googleMapsLink} target="_blank" rel="noopener noreferrer" className="text-white/40 text-sm leading-relaxed hover:text-[#E8C87A] transition-colors duration-300">
                  {contactInfo.address}
                </a>
              </div>
              {contactInfo.phones.map((phone) => (
                <div key={phone} className="flex items-center gap-3">
                  <Phone className="w-4 h-4 text-[#E8C87A] flex-shrink-0" />
                  <a href={`tel:${phone.replace(/\s/g, '')}`} className="text-white/40 hover:text-[#E8C87A] transition-colors duration-300 text-sm">
                    {phone}
                  </a>
                </div>
              ))}
              <div className="flex items-center gap-3">
                <Mail className="w-4 h-4 text-[#E8C87A] flex-shrink-0" />
                <a href={`mailto:${contactInfo.email}`} className="text-white/40 hover:text-[#E8C87A] transition-colors duration-300 text-sm">
                  {contactInfo.email}
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className="border-t border-white/5">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-6">
          <div className="flex flex-col md:flex-row items-center justify-between gap-4">
            <p className="text-white/30 text-sm">
              © {new Date().getFullYear()} Chris IELTS Consulting. All rights reserved.
            </p>
            <div className="flex gap-6">
              <a href="#" className="text-white/30 hover:text-[#E8C87A] transition-colors duration-300 text-sm">Privacy Policy</a>
              <a href="#" className="text-white/30 hover:text-[#E8C87A] transition-colors duration-300 text-sm">Terms of Service</a>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
};
